import React from 'react';
import { useIntl } from 'react-intl';
import { useGetUsers } from 'services/2n/get-all-users';
import { useGetZones } from 'services/2n/zones';
import { FilterModal } from 'components/modals/FilterModal';
import { categoryOptions, columnOptions, credentialsOptions, operatorOptions } from './constants';

export const AccessLogsFilterModal = ({ isOpen, onClose, currentFilter, onApply }) => {
  const intl = useIntl();
  const { users } = useGetUsers();
  const { zones } = useGetZones();

  const userOptions = (users || []).map((u) => ({
    key: u.Id || u.Name,
    text: u.Name,
    value: u.Id || u.Name,
  }));

  const zoneOptions = (zones || []).map((g) => ({
    key: g.Id || g.Name,
    text: g.Name,
    value: g.Id || g.Name,
  }));

  const dropdownOptionsMap = {
    user: userOptions,
    category: categoryOptions,
    zone: zoneOptions,
    credentials: credentialsOptions,
  };

  const dropdownColumns = ['user', 'category', 'zone', 'credentials'];
  const translateOptions = options => options.map(option => ({
    ...option,
    text: intl.formatMessage({ id: option.translationKey, defaultMessage: option.text }),
  }));

  return (
    <FilterModal
      isOpen={isOpen}
      onClose={onClose}
      currentFilter={currentFilter}
      onApply={onApply}
      columnOptions={translateOptions(columnOptions)}
      operatorOptions={translateOptions(operatorOptions)}
      dropdownOptionsMap={{
        ...dropdownOptionsMap,
        category: translateOptions(categoryOptions),
        credentials: translateOptions(credentialsOptions),
      }}
      dropdownColumns={dropdownColumns}
      headerTitle={intl.formatMessage({
        id: 'accessLogsFilterTitle',
        defaultMessage: 'Filter Access Logs',
      })}
    />
  );
};

